
import Group from 'vux/src/components/group/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'

import {
getCommodityDetail,
putAddMadeLossCart,
putDeleteCart,
getShoppingCartQty,
GetCommodityDetailForMatch,
} from "./../../service/index";
import { go } from "./../../util/router";
import { zdsCategory } from "./../../config/env";
import { getItem } from "@/util/jwtAuth";
import list from "./../product/list.vue";
export default {
data() {
return {
zdsCategory: zdsCategory,
Detail: { Price: 0 },
Qty: 0,
CartData: {},
IsOrder: true,
otype: "", // 现货抢购|现货选配|其他
};
},
components: {
Group,
XNumber,
list: list,
},
created() {
try {
this.otype = this.$route.query.otype;






} catch (err) {}
this.GetDetail();
this.getShopCartQty();
let store = getItem("ZDS_Store");
if (store) {
if (!(store.name === "10" || store.name === "20")) {
this.IsOrder = false;
}
}
},
mounted() {
window.onscroll = null;
},
watch: {
"": function (to, from) {},
},
methods: {
GetDetail() {
let vm = this;
let pData = {
commodityOid: vm.$route.params.id,
bannerOId: vm.$route.query.bannerOId, //专区id
};


if (this.otype === "XHXP") {
GetCommodityDetailForMatch(pData, (result) => {
console.log(JSON.parse(result.data));
/*
字段名	字段类型	含义
ZQSJZ	number	最小金重
ZJZJZ	number	最大金重
ZPJJZ	string	平均金重
ReferencePrice	string	全国统一价
ProcessingFee	string	工费
ZSJGY	string	工艺
ZSJCL	string
*/
if (result.code === "1") {
vm.Detail = JSON.parse(result.data);
vm.Detail.Qty = 0;
vm.Detail.Note = "";
}
});
} else {
getCommodityDetail(pData, (result) => {
if (result.code === "1") {
vm.Detail = JSON.parse(result.data);
vm.Detail.Qty = 0;
vm.Detail.Note = "";
}
});
}
},
doDetail(idx) {
let vm = this;
if (!vm.IsOrder) {
vm.showAlert("抱歉，您未分配下单权限，请联系管理员！");
return;
}
switch (idx) {
case 0:

if (!vm.Detail.IsCashOrder) {
vm.showAlert("抱歉，现货采购暂未开放!");
return;
}
if (vm.Detail.StockQty > 0) {

this.$router.push({
name: "list",
path: "/list/" + vm.$route.params.id,
query: {
bannerOId: this.$route.query.bannerOId, //专区id
},
params: { commodity: vm.Detail },
});
} else {
vm.showAlert("该商品没有库存,无法下单!");
}
break;
case 1:

if (!vm.Detail.ZYDDH) {
vm.showAlert(
`<p class="red">抱歉，该商品不支持下单，请前往常规配货专区下单。将会有线下工作人员帮您配货。<p>`
);

return;
}
go(
"/outbatchdetail/" +
vm.Detail.MARA_MTART +
"/" +
vm.$route.params.id,
this.$router
);
break;
case 2:






this.$router.push({
path:
"/matchsdetail/" +
vm.Detail.MARA_MTART +
"/" +
vm.$route.params.id,
query: {
bannerOId: this.$route.query.bannerOId, //专区id
},
});
break;
case 9:
go("/shopcart", this.$router);
break;
default:
break;
}
},
putAddMadeLossCart() {
let vm = this;
let pData = {
CommodityOid: vm.Detail.OId,
Qty: vm.Detail.Qty,
Note: vm.Detail.Note,
};

putAddMadeLossCart(pData, (result) => {
if (result.code === "1") {
vm.getShopCartQty();
}
});
},
putDeleteCart() {
let vm = this;
let pData = {
CartDetails: [
{
BigZDL: vm.Detail.MARA_MTART,
CommodityOid: vm.Detail.OId,
Qty: vm.Detail.Qty,
},
],
};
putDeleteCart(pData, (result) => {
if (result.code === "1") {
vm.getShopCartQty();
}
});
},
changeQty(val) {
this.Detail.Qty = val;
this.putAddMadeLossCart();
},
getShopCartQty() {
let vm = this;
getShoppingCartQty((result) => {
if (result.code === "1") {
vm.CartData = JSON.parse(result.data);
}
});
},
},
};



// WEBPACK FOOTER //
// ./src/page/product/index.vue